module.exports = __webpack_public_path__ + "static/img/userType.b8b32fcd.png";